export function recoveryReducer(state = {
    LATE: [],
    ALMOST_LATE: [],
    ALERTS: [],
    ENDS: []
},{
    type,
    payload
}){
    switch(type){
        case "GET_RECOVERY_LIST":
            let list = Object.assign({}, state)
            list.LATE = payload
            return list;
        case "GET_ALMOST_LATE_LIST":
            let list2 = Object.assign({}, state)
            list2.ALMOST_LATE = payload
            return list2;
        case "GET_CUSTOM_RECOVERY_LIST":
            let list3 = Object.assign({}, state)
            list3[payload.list_type.toUpperCase()+"S"] = payload.list
            return list3;
        // case "UPDATE_REPORT":
        //     return {...state, [payload.id]: payload};
        // case "POPUP_CLIENT_MESSAGES_LIST": // ??
        //     return state;
        default:
            return state;
    }
}